import PropTypes from 'prop-types';

import '../../styles/revamp/referral-reward-section.scss';

const ReferralRewardSection = (props) => {
  const { translations } = props;

  return (
    <div className="referral-reward-container">
      <h1
        className="referral-reward-heading"
        data-key="referral::reward_details_section::reward_heading"
        data-lokalise=""
      >
        {translations.reward_heading}
      </h1>
      <div className="referral-reward-content">
        <p
          className="reward-content1"
          data-key="referral::reward_details_section::reward_content1"
          data-lokalise=""
        >
          {translations.reward_content1}
        </p>
        <p
          className="reward-content2"
          data-key="referral::reward_details_section::reward_content2"
          data-lokalise=""
        >
          {translations.reward_content2}
        </p>
      </div>
    </div>
  );
};

ReferralRewardSection.propTypes = {
  translations: PropTypes.shape().isRequired
};
export default ReferralRewardSection;
